import { render, staticRenderFns } from "./CopyToInvite.vue?vue&type=template&id=892c9628&scoped=true"
import script from "./CopyToInvite.vue?vue&type=script&lang=js"
export * from "./CopyToInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892c9628",
  null
  
)

export default component.exports